import css from 'styled-jsx/css';

const staticStyles = css.global`
  .SelectLinkDistributionModal__overlay {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
  }

  .SelectLinkDistributionModal__overlay .ReactModal__Content--after-open {
    width: 1100px !important;
    max-width: calc(100vw - 40px) !important;
    border-radius: 4px !important;
    padding: 0 !important;
  }

  .SelectLinkDistributionModal__overlay .BasicModal__close {
    position: absolute !important;
    top: 20px !important;
    right: 20px !important;
    width: 28px !important;
    display: block !important;
  }

  .SelectLinkDistributionModal__modal {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 26px 24px 22px !important;
    color: #5f636d;
  }

  .SelectLinkDistributionModal__modal > h2 {
    margin: 0 42px 30px 0;
    color: #343a40;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
  }

  .SelectLinkDistributionModal__modal > p {
    display: none;
  }

  .SelectLinkDistributionModal {
    width: 100%;
    color: #5f636d;
  }

  .SelectLinkDistributionModal__filters {
    display: flex;
    align-items: center;
    gap: 18px;
    margin: 0 0 16px;
  }

  .SelectLinkDistributionModal__filters label {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #343a40;
    font-size: 15px;
    font-weight: 600;
  }

  .SelectLinkDistributionModal__filters input,
  .SelectLinkDistributionModal__filters select {
    height: 36px;
    box-sizing: border-box;
    border: 1px solid #d9e2ec;
    border-radius: 3px;
    padding: 0 12px;
    color: #5f636d;
    background: #fff;
    font-size: 14px;
    outline: none;
  }

  .SelectLinkDistributionModal__filters input {
    width: 226px;
  }

  .SelectLinkDistributionModal__filters select {
    width: 170px;
    appearance: auto;
  }

  .SelectLinkDistributionModal__filters input:focus,
  .SelectLinkDistributionModal__filters select:focus {
    border-color: #65b5f1;
    box-shadow: 0 0 0 2px rgba(61, 157, 232, 0.12);
  }

  .SelectLinkDistributionModal__filters .DefaultButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: 100px;
    height: 36px;
    border: 1px solid #3d9de8;
    border-radius: 3px;
    color: #3d9de8;
    background: #fff;
    font-size: 14px;
  }

  .SelectLinkDistributionModal__filters .DefaultButton:first-of-type {
    color: #fff;
    background: #3d9de8;
  }

  .SelectLinkDistributionModal__table-wrapper {
    overflow-x: auto;
    border: 1px solid #e2e8f0;
  }

  .SelectLinkDistributionModal table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    white-space: nowrap;
  }

  .SelectLinkDistributionModal th,
  .SelectLinkDistributionModal td {
    border-right: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
    padding: 0 12px;
    height: 52px;
    text-align: center;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  .SelectLinkDistributionModal th {
    height: 48px;
    color: #343a40;
    background: #f7f9fc;
    font-size: 14px;
    font-weight: 600;
  }

  .SelectLinkDistributionModal th:first-child,
  .SelectLinkDistributionModal td:first-child {
    width: 5%;
    padding: 0;
    text-align: center;
  }

  .SelectLinkDistributionModal th:first-child > .Checkbox__wrapper,
  .SelectLinkDistributionModal td:first-child > .Checkbox__wrapper {
    margin: 0 auto;
  }

  .SelectLinkDistributionModal th:nth-child(2),
  .SelectLinkDistributionModal td:nth-child(2) {
    width: 6%;
  }

  .SelectLinkDistributionModal th:nth-child(3),
  .SelectLinkDistributionModal td:nth-child(3) {
    width: 19%;
    text-align: left;
  }

  .SelectLinkDistributionModal th:nth-child(4),
  .SelectLinkDistributionModal td:nth-child(4) {
    width: 12%;
  }

  .SelectLinkDistributionModal th:nth-child(5),
  .SelectLinkDistributionModal td:nth-child(5) {
    width: 10%;
  }

  .SelectLinkDistributionModal th:nth-child(6),
  .SelectLinkDistributionModal td:nth-child(6) {
    width: 12%;
  }

  .SelectLinkDistributionModal th:nth-child(7),
  .SelectLinkDistributionModal td:nth-child(7) {
    width: 20%;
  }

  .SelectLinkDistributionModal th:last-child,
  .SelectLinkDistributionModal td:last-child {
    width: 16%;
    border-right: 0;
  }

  .SelectLinkDistributionModal tbody tr:last-child td {
    border-bottom: 0;
  }

  .SelectLinkDistributionModal tbody tr.SelectLinkDistributionModal__row--unavailable td {
    color: #a7adb5;
    background: #f4f5f7;
  }

  .SelectLinkDistributionModal tbody tr.SelectLinkDistributionModal__row--unavailable
    .SelectLinkDistributionModal__attribute-badge,
  .SelectLinkDistributionModal tbody tr.SelectLinkDistributionModal__row--unavailable
    .SelectLinkDistributionModal__tag-badge {
    opacity: 0.6;
  }

  .SelectLinkDistributionModal__attribute-badge,
  .SelectLinkDistributionModal__tag-badge {
    display: inline-flex;
    align-items: center;
    min-height: 28px;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 3px 8px;
    font-size: 14px;
  }

  .SelectLinkDistributionModal__attribute-badge {
    border: 1px solid #91c9ff;
    color: #3d9de8;
    background: #fff;
  }

  .SelectLinkDistributionModal__attribute-badge--markup {
    border-color: #f3c98e;
    color: #e9a12f;
  }

  .SelectLinkDistributionModal__tag-badge {
    border: 1px solid #d5e9ff;
    color: #3d9de8;
    background: #edf6ff;
  }

  .SelectLinkDistributionModal__empty {
    padding: 30px !important;
  }

  .SelectLinkDistributionModal__pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 0 28px;
    color: #6d737d;
    font-size: 14px;
  }

  .SelectLinkDistributionModal__pagination select {
    width: 114px;
    height: 34px;
    border: 1px solid #d9e2ec;
    border-radius: 3px;
    padding: 0 10px;
    color: #6d737d;
    background: #fff;
    font-size: 14px;
  }

  .SelectLinkDistributionModal__pagination button {
    width: 24px;
    height: 34px;
    border: 0;
    background: transparent;
    color: #aeb8c4;
    font-size: 26px;
    line-height: 1;
    cursor: pointer;
  }

  .SelectLinkDistributionModal__pagination button:disabled {
    color: #d7dde5;
    cursor: default;
  }

  .SelectLinkDistributionModal__pagination strong {
    min-width: 24px;
    color: #3d9de8;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }

  .SelectLinkDistributionModal__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0;
    color: #6d737d;
    font-size: 16px;
  }

  .SelectLinkDistributionModal__footer strong {
    color: #398ef5;
  }

  .SelectLinkDistributionModal__footer > div {
    display: flex;
    gap: 10px;
  }

  .SelectLinkDistributionModal__footer .DefaultButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: 80px;
    height: 36px;
    border: 1px solid #d9e2ec;
    border-radius: 3px;
    color: #6d737d;
    background: #fff;
    font-size: 14px;
  }

  .SelectLinkDistributionModal__filters .DefaultButton__text,
  .SelectLinkDistributionModal__footer .DefaultButton__text {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
  }

  .SelectLinkDistributionModal__footer .DefaultButton.filled:not(:disabled) {
    border-color: transparent;
    color: #fff;
    background: linear-gradient(90deg, #1ea8ed 0%, #25ddbe 100%);
    box-shadow: 0 4px 10px rgba(30, 168, 237, 0.28);
  }

  .SelectLinkDistributionModal__footer .DefaultButton.filled:not(:disabled):hover {
    background: linear-gradient(90deg, #149be0 0%, #18ceb0 100%);
    box-shadow: 0 5px 12px rgba(30, 168, 237, 0.36);
  }

  .SelectLinkDistributionModal__footer .DefaultButton.filled:disabled {
    border-color: transparent;
    background: #c8d1dc;
    box-shadow: none;
  }

  .SelectLinkDistributionModal__footer .DefaultButton:disabled {
    cursor: default;
  }

  @media (max-width: 767px) {
    .SelectLinkDistributionModal__overlay .ReactModal__Content--after-open {
      max-width: calc(100vw - 20px) !important;
    }

    .SelectLinkDistributionModal__modal {
      padding: 22px 16px 18px !important;
    }

    .SelectLinkDistributionModal__filters {
      align-items: stretch;
      flex-wrap: wrap;
      gap: 10px;
    }

    .SelectLinkDistributionModal__filters label {
      width: 100%;
      justify-content: space-between;
    }

    .SelectLinkDistributionModal__filters input,
    .SelectLinkDistributionModal__filters select {
      width: calc(100% - 52px);
    }
  }
`;

export { staticStyles };
